import React from "react";
import { Landing } from "../components/Landing";

// Page d'une campagne fournisseur (une URL d'annonce = une entrée de PROVIDERS dans config/providersData.js).
// Les boutons d'appel prennent la couleur du fournisseur ; encadré « … n'est pas [marque] » obligatoire.
export function ProviderPage({ provider, path }) {
  return <Landing provider={provider} path={path} />;
}
